var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.068 8.02c-.064-.01-.13-.023-.2-.036-1.827-.34-5.337-.992-8.529.109C2.748 9.33 1.283 11.6 1 12.58c.62 2.941 1.935 6.733 6.655 6.424l.094-.007c1.126-.096 2.22-.576 3.233-1.254.335-.225.66-.472.976-.733.893-.742 1.7-1.605 2.38-2.437a22.28 22.28 0 0 0 1.75-2.457l.146.129c.527.462 1.303 1.143 2.18 1.812 1.311 1.004 2.846 1.982 4.097 2.16 2.708.388 9.13-.309 8.435-4.642-.697-4.334-4.876-5.65-9.054-5.572-2.933.055-5.087 1.304-6.077 1.888a21.275 21.275 0 0 1-.346.203c-.12-.02-.254-.045-.402-.072zm-1.675 2.754c-1.795-.3-4.042-.547-6.076.155-1.807.622-2.724 1.512-3.14 2.042.255.923.568 1.669.978 2.193.387.497.938.935 2.304.845.804-.053 1.951-.649 3.276-1.933 1.15-1.114 2.1-2.423 2.657-3.303zm4.824-.782c.934-.48 2.164-.96 3.732-.99 1.818-.033 3.349.251 4.391.794.911.474 1.465 1.128 1.646 2.255.02.13.014.196.01.215a.272.272 0 0 1-.014.02c-.077.092-.345.327-.99.558-1.319.474-3.096.542-4.055.405-.292-.042-1.067-.385-2.229-1.224-.965-.696-1.853-1.473-2.49-2.032zm9.779 2.277v-.002zM11.264 21.04a6.71 6.71 0 0 1-.283-1.032H22.9c-.278.808-.862 1.972-1.75 3-1.096 1.268-2.656 2.33-4.673 2.262-1.95-.066-3.295-1.076-4.173-2.262a7.662 7.662 0 0 1-1.04-1.968z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/SUN.c59a659f2b056c478fadfd04125e26b1.svg";
export { ForwardRef as ReactComponent };